import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("valorian_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use((r) => r, (err) => {
  const url = err.config?.url || "";
  if (err.response?.status === 401 && !url.includes("/auth/") && localStorage.getItem("valorian_token")) {
    localStorage.removeItem("valorian_token");
    window.location.href = "/login";
  }
  return Promise.reject(err);
});

export default api;
